export default defineNuxtPlugin(async () => {
    const { $customClientErrorHandler } = useNuxtApp();
    const { datadogLogs } = await import("@datadog/browser-logs");

    const config = useRuntimeConfig();

    if(config.public.appEnvironment === 'local' ||
        !config.public.ddClientToken){
        return false;
    }

    const options = {
        clientToken: config.public.ddClientToken,
        site: 'datadoghq.eu',
        version:config.public.version,
        env: config.public.appEnvironment,
        service: config.public.appRegion === 'BE' ? 'eu24-web-be':'eu24-web',
        forwardErrorsToLogs: true,
        forwardConsoleLogs:'all',
        sessionSampleRate: 100
    }

    try {
        const url = useRequestURL()
        datadogLogs.init(options)

        // Add custom 'host' and 'source' attributes
        datadogLogs.setGlobalContext({
            host: url.host
        });

        const authStore = useAuthStore();
        /**
         * @description verify cookie consent first before sending user data to datadog
         */

        if(authStore.is_authenticated) {
            datadogLogs.setUser({
                id:authStore.user.id,
                email:authStore.user.email,
                name:authStore.user.first_name +' '+authStore.user.last_name
            });
        }

        if(config.public.appDebug) {
            const debugStore = useDebugStore();
            debugStore.services.dataDogBrowserLogs.enabled = true;
            debugStore.services.dataDogBrowserLogs.clientToken = config.public.ddClientToken;
        }

        return {
            provide: {
                ddLogs: datadogLogs,
            },
        };

    } catch (e) {
        let errorMeta = {options, dataDogPluginError: true}

        $customClientErrorHandler(
            e,
            'high',
            'Datadog Log Plugin Error - trying to monitoring services using datadog log',
            errorMeta
        );
    }
});
